import React from "react";
import style from "./Navigation.module.scss";
import { Link, useRouteMatch } from "react-router-dom";
import { Badge } from "antd";
import { RateOtherAtom } from "../../../../pages/My/Store";
import { useAtomValue } from "jotai";
import { isTrue } from "../../../../service/service";
import { DownloadVideos } from "../DownloadVideos";

export default React.memo(function Navigation({ counts }: { counts?: number }) {
    const match = useRouteMatch();

    function isMath(path: string) {
        if (path === "/")
            return (
                match.path === "/" || match.path.indexOf("/course/Rows") === 0
            );
        return match.path.indexOf(path) === 0;
    }

    const { flag: MyDotFlag } = useAtomValue(RateOtherAtom);

    return (
        <ul className={style.root}>
            <li className={`${style.item} ${isMath("/") ? style.current : ""}`}>
                <Link to="/">首页</Link>
            </li>

            <Badge dot={isTrue(MyDotFlag)}>
                <li
                    className={`${style.item} ${
                        isMath("/my") ? style.current : ""
                    }`}>
                    <Link to="/my">我的</Link>
                </li>
            </Badge>

            <li
                className={`${style.item} ${
                    isMath("/homework") ? style.current : ""
                }`}>
                <Link to="/homework">作业</Link>
            </li>

            <li
                className={`${style.item} ${
                    isMath("/askTeacher") ? style.current : ""
                }`}>
                <Link to="/askTeacher">答疑</Link>
            </li>

            <li
                className={`${style.item} ${
                    isMath("/chat") ? style.current : ""
                }`}>
                <Link to="/chat">私信</Link>
            </li>

            <li
                className={`${style.item} ${
                    isMath("/exam") ? style.current : ""
                }`}>
                <Link to="/exam/main">考试</Link>
            </li>

            <li
                className={`${style.item} ${
                    isMath("/notice") ? style.current : ""
                }`}>
                <Link to="/notice" style={{ position: "relative" }}>
                    通知
                    {!!counts && (
                        <div
                            className={style.badge}
                            style={{ display: counts > 0 ? "block" : "none" }}>
                            <p>{counts > 99 ? "99+" : counts}</p>
                        </div>
                    )}
                </Link>
            </li>

            <li className={style.item} style={{ display: "none" }}>
                <DownloadVideos />
            </li>
        </ul>
    );
});
